

































































import {Vue, Component, Prop} from "vue-property-decorator";
import QuestionTooltip from "@/components/question_components/QuestionTooltip.vue";
import {
    UserInputAdditionalInfoType,
    AdditionalInfoQuestionType
} from "@/types/surveyTab.type";

@Component({
    components: {
        QuestionTooltip
    }
})
export default class CommentQuestion extends Vue {
    @Prop() value!: UserInputAdditionalInfoType;
    @Prop() question!: AdditionalInfoQuestionType;
    hover = false;

    get showBookmarker() {
        if (this.hover || this.value.bookmarked) {
            return true;
        } else return false;
    }
}
